import { Model } from '@vuex-orm/core'
import shortid from 'shortid'
import moment from "moment/moment"
import store from '../store';
import RequestOrderPayment from './RequestOrderPayment';

export default class PaymentMethod extends Model {
    static entity = 'paymentMethods'
    static fields() {
        return {
            id: this.attr('tmp/' + shortid.generate()),
            addons: this.attr(null),
            zepplinId: this.attr(null),
            name: this.attr(null),
            companyId: this.attr(null),
            tax: this.attr(0),
            taxUnit: this.attr(null),
            isDefault: this.attr(null),
            autoPay: this.attr(0),
            hasDeadline: this.attr(0),
            deadlineRule: this.attr(null),
            dateUpdated: this.attr(moment()),
            dateCreated: this.attr(moment()),
            dateRemoved: this.attr(null),
            status: this.attr(null),
            zepplinCompanyPaymentMethod: this.attr({
                paymentMethodId: null
            }),
            paymentMethodRequestOrderPayments: this.hasMany(RequestOrderPayment, 'paymentMethodId')
        }
    }

    static beforeCreate(model) {
        if(!model.companyId) model.companyId = store.state.auth.user.defaultCompanyId
    }

    static deleteById(id) {
        const paymentMethod = PaymentMethod.find(id)
        if(paymentMethod.paymentMethodRequestOrderPayments && paymentMethod.paymentMethodRequestOrderPayments.length !== 0) return
        paymentMethod.$delete(id)
    }

}